import {
    isManualEntryPlatformCostProviderId,
    listPlatformCostProviderIds,
    providerCatalog,
} from '@actions/services/platformCosts/catalog';
import type { BuildSidebarItemsParams, CostSidebarItem } from '../types';

const buildSidebarItems = ({
    providerSpendById,
    overviewMonthToDateCents,
    customProviders,
}: BuildSidebarItemsParams): CostSidebarItem[] => {
    const catalogItems = listPlatformCostProviderIds()
        .filter(providerId => {
            const ingestionMode = providerCatalog[providerId].ingestionMode;
            return ingestionMode === 'api_sync' || ingestionMode === 'manual_entry';
        })
        .map(providerId => {
            const hasSpend = Object.prototype.hasOwnProperty.call(providerSpendById, providerId);
            const isManualEntry = isManualEntryPlatformCostProviderId(providerId);

            let hint: string | null = 'Sync to load';
            if (hasSpend) {
                hint = null;
            } else if (isManualEntry) {
                hint = 'Enter billing';
            }

            return {
                key: providerId,
                label: providerCatalog[providerId].name,
                path: providerId,
                isEnabled: true,
                hint,
                amountCents: hasSpend ? providerSpendById[providerId] : null,
            };
        });

    const customItems = customProviders.map(provider => {
        const hasSpend = Object.prototype.hasOwnProperty.call(providerSpendById, provider.id);
        return {
            key: provider.id,
            label: provider.displayName,
            path: provider.id,
            isEnabled: true,
            hint: hasSpend ? null : 'Enter billing',
            amountCents: hasSpend ? providerSpendById[provider.id] : null,
        };
    });

    return [
        {
            key: 'overview',
            label: 'Overview',
            path: '',
            isEnabled: true,
            hint: null,
            amountCents: overviewMonthToDateCents,
        },
        ...catalogItems,
        ...customItems,
    ];
};

export default buildSidebarItems;
